import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ShopTheming, ThemingService } from 'src/app/theming.service';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import Quill from 'quill';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-edit-component',
  templateUrl: './edit-component.component.html',
  styleUrls: ['./edit-component.component.scss']
})
export class EditComponentComponent implements OnInit {
  @Input() componentId!: number;
  @Output() close = new EventEmitter<void>();
  public shopTheme: ShopTheming[] = [];
  loading: boolean = false;
  timestamp: number;
  selectedParentId: number = 0;
  deletedInfoIds: number[] = [];
  minItems: number = 0;
  maxItems: number = 0;
  errorMessage: string = '';
  collections: any [] = [];
  clientSubscriptions: any [] = [];
  categories: any [] = [];
  subCategories: any [] = [];
  subSubCategories: any [] = [];
  componentTypes: any[] = [];
  selectedOption: any;
  componentParentId: any;
  categoryId: number = 0;
  subCategoryId: number = 0;
  subSubCategoryId: number = 0;
  collectionId: number = 0;
  subsAllowed: any = "";
  productComponentType: number = 0;
  descriptionText: string = '';
  textLength: number = 0;
  maxLength: number = 2500;
  componentForm!: FormGroup;
  remainingCharacters: number = this.maxLength;
  infoMaxLength: number = 2500;
  remainingInfoCharacters: number = this.infoMaxLength;
  urlsToDelete: string[] = [];
  itemListId: string = '';

  activeSubscriptions = 0;
  selectedSubscriptions: number[] = [];

  component: any = {
    componentImage: '',
    componentId: 0,
    status: 0,
    position: 0,
    itemQuantity: 0,
    infoImageUrl: '',
    title: '',
    subtitle: '',
    shopContactMail: '',
    redirectUrl: '',
    infoDescription: '',
    clientSubscriptionsAllowed: '',
    description: '',
    infoIds: '',
    infoTitles: '',
    urlNames: '',
    componentInfo: []
  };

  registerFonts() {
      const FontAttributor = Quill.import('attributors/class/font');
      FontAttributor.whitelist = [
      'arial',
      'inter',
      'lato',
      'merriweather',
      'montserrat',
      'nunito',
      'pacifico',
      'poppins',
      'raleway',
      'roboto',
      'serif',
      ];

      Quill.register(FontAttributor, true);
    }

  modules = {
    'emoji-shortname': true,
    'emoji-textarea': true,
    'emoji-toolbar': true,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons //['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction
      [{size: ['small', false, 'large', 'huge'],},], // custom dropdown
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ align: [] }],
      ['link'],
      ['emoji'],
      ['clean'], // remove formatting button
      [
        {
          font: [
          'arial',
          'inter',
          'lato',
          'merriweather',
          'montserrat',
          'nunito',
          'pacifico',
          'poppins',
          'raleway',
          'roboto',
          'serif',
          ],
        },
      ],
    ],
  };

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private themingService: ThemingService,
    public appComponent: AppComponent,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private lambdaService: LambdaService
  ) {
    this.timestamp = Date.now();
    this.route.paramMap.subscribe((params) => {
      let componentId = Number(params.get('componentId'));
      if (componentId !== this.componentId) {
        this.appComponent.goToTop();
        this.componentId = componentId;
      }
    });
  }

  fieldVisibilityConfig: { [key: number]: string[] } = {
    1: ['infoImageUrl', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'],
    2: ['infoImageUrl', 'infoDescription', 'redirectUrl'],
    3: ['infoImageUrl', 'title', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'],
    4: ['infoImageUrl', 'title', 'description', 'infoTitle', 'infoDescription', 'redirectUrl'],
    5: ['infoImageUrl', 'title', 'description', 'infoTitle', 'infoDescription', 'redirectUrl'],
    6: ['title', 'description', 'infoTitle', 'infoDescription', 'redirectUrl'],
    7: ['infoImageUrl', 'title', 'description', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'],
    8: ['title', 'subtitle', 'itemQuantity'],
    9: ['title', 'subtitle', 'itemQuantity'],
    10: ['title', 'subtitle', 'itemQuantity'],
    11: ['infoImageUrl', 'title', 'description', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'],
    12: ['infoImageUrl', 'redirectUrl'],
    13: ['title', 'subtitle', 'description', 'redirectUrl'],
    14: ['title', 'subtitle', 'description', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName', 'infoImageUrl'],// Pricing cards
    15: ['infoImageUrl', 'redirectUrl', 'urlName'],
    16: ['infoImageUrl', 'redirectUrl'],
    17: ['infoVideoUrl', 'redirectUrl', 'infoTitle', 'infoDescription'],
    18: ['infoVideoUrl', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'],
    19: ['title', 'infoImageUrl', 'redirectUrl'], // Slider-Gallery
    20: ['title', 'subtitle', 'infoImageUrl', 'redirectUrl'], // Vertical-Gallery
    21: ['title', 'subtitle', 'infoImageUrl', 'redirectUrl'], // Horzontal-Gallery
    22: ['infoVideoUrl','redirectUrl'], // Video Banner
    23: ['title', 'infoImageUrl', 'infoTitle', 'infoDescription', 'redirectUrl', 'urlName'], // 1 Tarjeta con imagen a la derecha titulo y descripcion
    24: ['title', 'description', 'shopContactMail'], // formulario de contacto,
    25: ['title', 'description', 'infoImageUrl', 'infoTitle', 'infoDescription', 'redirectUrl'], // 3 Tarjetas inclinadas horizontales con efecto hover
    26: ['title', 'description', 'infoImageUrl', 'infoTitle', 'infoDescription', 'redirectUrl'], // 2-3 Tarjetas verticales con efecto hover
    27: ['title', 'description', 'infoImageUrl', 'infoTitle', 'infoDescription', 'redirectUrl'], // 4 Tarjetas horizontales con efecto hover
  };

  getFieldVisibilityConfig(): string[] {
    return this.fieldVisibilityConfig[this.component.componentTypeId] || [];
  }

  ngOnInit(): void {
    this.loading = true;
    Promise.all([
      this.getComponentById(this.componentId),
      this.getCollections(),
      this.getCategories(),
      this.getSubCategories(),
      this.getSubSubCategories(),
      this.getComponentTypes(),
      this.registerFonts(),
      this.getClientSubscriptions()
    ]).then(() => {
      this.loading = false;
      if (this.component?.description) {
        this.descriptionText = this.sanitizer.bypassSecurityTrustHtml(this.component.description) as string;
      }
    }).catch((error) => {
      console.error(error);
      this.loading = false;
    });
  }

  async getClientSubscriptions(){
    try {
      const response: any = await this.lambdaService.getClientSubscriptions(this.themingService.shopId);
      this.clientSubscriptions = Array.isArray(response.subscriptions) ? response.subscriptions : [];
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      this.clientSubscriptions = [];
    }
  }

  toggle() {
    this.activeSubscriptions = this.activeSubscriptions === 1 ? 0 : 1;
    if (this.activeSubscriptions === 0) {
      this.selectedSubscriptions = []
      this.subsAllowed = '0';
    }
  }

  // Método para manejar selección/deselección de suscripciones
  toggleSuscripcion(id: number) {
    const index = this.selectedSubscriptions.indexOf(id);
    if (index > -1) {
      this.selectedSubscriptions.splice(index, 1);
    } else {
      this.selectedSubscriptions.push(id);
    }
    if (this.selectedSubscriptions.length === 0) {
      this.subsAllowed = '';
    } else {
      this.subsAllowed = this.selectedSubscriptions.join(',');
    }
  }

  async getComponentById(id: number): Promise<void> {
    try {
      const data: any = await this.lambdaService.getComponentById(id, this.themingService.shopId);
      this.component = data;

      this.subsAllowed = this.component.clientSubscriptionsAllowed;
      if (this.subsAllowed === "0") {
        this.activeSubscriptions = 0;
        this.selectedSubscriptions = [];
      } else if (this.subsAllowed === "" || this.subsAllowed == null) {
        this.activeSubscriptions = 1;
        this.selectedSubscriptions = [];
      } else {
        this.activeSubscriptions = 1;
        this.selectedSubscriptions = this.subsAllowed.split(',').map((id: any) => +id.trim());
      }


      this.productComponentType = this.component.productComponentType;
      this.component.itemQuantity = this.component.itemQuantity;
      this.component.title = this.component.title;
      this.component.description = this.component.description;
      this.component.clientSubscriptionsAllowed = this.component.clientSubscriptionsAllowed;
      this.component.shopContactMail = this.component.shopContactMail;
      this.component.subtitle = this.component.subtitle;
      this.component.pageId = this.component.pageId;
      this.component.infoIds = this.component.componentInfo.map((info: any) => info.infoId).join('|');
      this.component.componentInfo.forEach((info: any) => {
        info.selected = false;
      });
      this.minItems = this.component.minItems;
      this.maxItems = this.component.maxItems;
      if (this.component.componentParentId == 3) {
        if (this.component.collectionId) {
          this.selectedOption = 'collections';
          this.collectionId = this.component.collectionId;
        } else if (this.component.categoryId) {
          this.selectedOption = 'categories';
          this.categoryId = this.component.categoryId;
        } else if (this.component.subCategoryId) {
          this.selectedOption = 'subCategories';
          this.subCategoryId = this.component.subCategoryId;
        } else if (this.component.subSubCategoryId) {
          this.selectedOption = 'subSubcategories';
          this.subSubCategoryId = this.component.subSubCategoryId;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async getComponentTypes(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getComponentTypes(this.themingService.shopId);
      this.componentTypes = response.data.filter((type: any) =>
        type.componentParentId === 3 && [8, 9, 10].includes(type.componentTypeId)
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onComponentTypeSelected(componentTypeId: number): void {
    this.component.componentTypeId = componentTypeId;
  }

  async getCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCategories(this.themingService.shopId);
      const categoryRows = Array.isArray(response[0]) ? response[0] : [];
      this.categories = categoryRows;
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }

  async getCollections(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getCollections(this.themingService.shopId);
      this.collections = Array.isArray(response.collections) ? response.collections : [];
    } catch (error) {
      console.error('Error fetching collections:', error);
      this.collections = [];
    }
  }

  async getSubCategories(): Promise<void> {
    this.loading = true;
    try {
      const response: any = await this.lambdaService.getSubCategories(this.themingService.shopId);
      this.subCategories = Array.isArray(response.subCategories) ? response.subCategories : [];
    } catch (error) {
      console.error('Error fetching subCategories:', error);
    } finally {
      this.loading = false;
    }
  }

  async getSubSubCategories(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSubSubCategories(this.themingService.shopId);
      const subSubCategoryRows = Array.isArray(response.subSubCategories) ? response.subSubCategories : [];
      this.subSubCategories = subSubCategoryRows;
    } catch (error) {
      console.error('Error fetching subSubCategories:', error);
    }
  }

  addNewField() {
    if (this.component.componentInfo.length >= this.maxItems) {
    this.errorMessage = `El máximo de items para este componente es de ${this.maxItems}.`;
    $('#errorEditMaxMinItemModal').modal('show');
    } else {
    const newInfoId = this.generateNewInfoId();
    this.component.componentInfo.push({
      infoId: newInfoId,
      infoDescription: '',
      infoImageUrl: '',
      redirectUrl: '',
      infoTitle: '',
      urlName: '',
      selected: false
    });
    this.errorMessage = '';
  }
  }

  onItemQuantityChange(event: any) {
    this.component.itemQuantity = event.target.value;
  }

  removeField(index: number) {
    if (this.component.componentInfo.length <= this.minItems) {
      this.errorMessage = `El mínimo de items para este componente es de ${this.minItems}.`;
      $('#errorEditMaxMinItemModal').modal('show');
    } else {
      const infoId = this.component.componentInfo[index].infoId;
      if (infoId > 0) {
        this.deletedInfoIds.push(infoId);
      }
      this.component.componentInfo.splice(index, 1);
      this.errorMessage = '';
    }
  }

  onOptionChange(option: string) {
    this.selectedOption = option;
    this.resetSelections();
    switch (option) {
      case 'categories':
        this.productComponentType = 1;
        break;
      case 'subCategories':
        this.productComponentType = 2;
        break;
      case 'subSubcategories':
        this.productComponentType = 3;
        break;
      case 'collections':
        this.productComponentType = 4;
        break;
      default:
        this.productComponentType = this.productComponentType || 0;
        break;
    }
  }

  onCategoryChange(event: any) {
    this.categoryId = event.target.value;
    this.subCategoryId = 0;
    this.subSubCategoryId = 0;
    this.collectionId = 0;
  }

  onSubCategoryChange(event: any) {
    this.subCategoryId = event.target.value;
    this.subSubCategoryId = 0;
    this.collectionId = 0;
  }

  onSubSubCategoryChange(event: any) {
    this.subSubCategoryId = event.target.value;
    this.collectionId = 0;
  }

  onCollectionChange(event: any) {
    this.collectionId = event.target.value;
    this.categoryId = 0;
    this.subCategoryId = 0;
    this.subSubCategoryId = 0;
  }

  isSelected(id: string): boolean {
    id = id.toString();
    if (this.component.clientSubscriptionsAllowed == '0') {
      return true;
    }
    if (this.component.clientSubscriptionsAllowed == '' ||  this.component.clientSubscriptionsAllowed == null) {
      return false;
    }
    const allowedIds = this.component.clientSubscriptionsAllowed
      .split(',')
      .map((subId: any) => subId.trim()) // Limpia espacios en blanco
      .filter((subId: any) => subId.length > 0); // Elimina entradas vacías si las hay
    return allowedIds.includes(id);
  }

  onSubscriptionChange(id: number, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    let subsAllowedArr: any;
    if(this.subsAllowed == ""){
      subsAllowedArr = [];
    }else{
      subsAllowedArr = this.subsAllowed.split(',');
    }
    if(this.component.clientSubscriptionsAllowed == '0'){
      subsAllowedArr = this.clientSubscriptions
      .map(subscription => subscription.clientSubscriptionId);
    }
    if (isChecked) {
      // Agrega al array si no está ya
      if (!subsAllowedArr.includes(id.toString())) {
        subsAllowedArr.push(id.toString());
      }
    } else {
      // Remueve del array
      subsAllowedArr = subsAllowedArr.filter((selectedId: any) => selectedId != id.toString());
    }
    // Convierte a cadena separada por comas
    const commaSeparated = subsAllowedArr.join(',');
    this.subsAllowed = commaSeparated;
    // Haz algo con él, e.g., guardar en servicio o API
    // this.someService.saveCollections(commaSeparated);
    // Opcional: Actualiza preview o valida
  }


  resetSelections() {
    this.categoryId = 0;
    this.subCategoryId = 0;
    this.subSubCategoryId = 0;
    this.collectionId = 0;
  }

  closeComponent() {
    this.close.emit();
  }

  descriptionChanged(event: any) {
    const quill = event.editor;
    if (event.event === 'text-change') {
      this.textLength = quill.getLength() - 1;
      this.remainingCharacters = this.maxLength - this.textLength;

      if (this.textLength > this.maxLength) {
        quill.deleteText(this.maxLength, this.textLength - this.maxLength);
        this.remainingCharacters = 0;
      }
    }
    if (event.event === 'selection-change' && event.range === null) {
      this.component.description = quill.root.innerHTML;
    }
  }

  changeComponentTitle(event: any) {
    const quill = event.editor;
    if (event.event === 'selection-change' && event.range === null) {
      this.component.title = quill.root.innerHTML;
    }
  }

  changeComponentSubtitle(event: any) {
    const quill = event.editor;
    if (event.event === 'selection-change' && event.range === null) {
      this.component.subtitle = quill.root.innerHTML;
    }
  }

  changeComponentInfoDescription(event: any, index: number): void {
    if (event.event === 'text-change') {
      const quill = event.editor;
      const infoTextLength = quill.getLength() - 1;
      this.remainingInfoCharacters = this.infoMaxLength - infoTextLength;
      if (infoTextLength > this.infoMaxLength) {
        quill.deleteText(this.infoMaxLength, infoTextLength - this.infoMaxLength);
        this.remainingInfoCharacters = 0;
      }
    }
  }

  changeComponentInfoTitle(event: any, index: number): void {
    const quill = event.editor;

    if (event.event === 'text-change') {
      const textLength = quill.getLength() - 1;
      this.remainingInfoCharacters = this.infoMaxLength - textLength;

      if (textLength > this.infoMaxLength) {
        quill.deleteText(this.infoMaxLength, textLength - this.infoMaxLength);
        this.remainingInfoCharacters = 0;
      }
    }

    // Captura solo cuando el usuario termina de editar (blur)
    if (event.event === 'selection-change' && event.range === null) {
      this.component.componentInfo[index].infoTitle = quill.root.innerHTML;
    }
  }


  changeComponentName(event: string) {
    this.component.componentName = event;
  }

  changeComponentRedirectUrl(event: string, index: number) {
    this.component.componentInfo[index].redirectUrl = event;
  }

  changeComponentUrlName(event: string, index: number) {
    this.component.componentInfo[index].urlName = event;
  }

  sanitizeImageURL(imageURL: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageURL);
  }

  sanitizeVideoURL(videoURL: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
  }

  triggerFileInput(index: number | null = null, type: 'image' | 'video'): void {
    const inputId = type === 'image' ? `btn-upload-image-${index}` : `btn-upload-video-${index}`;
    const uploadButton = document.getElementById(inputId) as HTMLInputElement;

    if (uploadButton) {
      uploadButton.click();
    }
  }

  removeMedia(index: number, field: 'infoImageUrl' | 'infoVideoUrl') {
    this.component.componentInfo[index][field] = '';
    this.component.componentInfo[index].blob = null;
    this.component.componentInfo[index].videoBlob = null;
  }

  generateNewInfoId(): number {
    return -1 * Date.now();  // Generate a negative timestamp as a temporary ID
  }

  handleVideoManualURLChange(index: number, event: any): void {
    const url = event.target.value.trim();
    const info = this.component.componentInfo[index];

    if (url === info.infoVideoUrl) return;

    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
    const match = url.match(youtubeRegex);

    if (match) {
      info.infoVideoUrl = `https://www.youtube.com/embed/${match[1]}`;
      info.isYouTube = true;
    } else {
      info.infoVideoUrl = url;
      info.isYouTube = false;
    }

    if (info.videoUrlType == 2) {
      info.videoManualURL = url;
    }

    info.videoBlob = null;
  }


  onFileSelected(event: any, index: number, type: 'image' | 'video'): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const maxSize = 12 * 1024 * 1024;
    if (file.size > maxSize) {
      $('#errorFileSizeModal').modal('show');
      event.target.value = '';
      return;
    }
    const info = this.component.componentInfo[index];
    if (type === 'image' && info.infoImageUrl?.includes('mobydyg-files.s3.amazonaws.com')) {
      this.urlsToDelete.push(info.infoImageUrl);
    }
    if (type === 'video' && info.videoUrlType == 1 && info.infoVideoUrl?.includes('mobydyg-files.s3.amazonaws.com')) {
      this.urlsToDelete.push(info.infoVideoUrl);
    }

    if (type === 'image') {
      this.convertImageToWebP(file, 1920, 0.8)
        .then((webpFile) => {
          const previewUrl = URL.createObjectURL(webpFile);
          info.infoImageUrl = this.sanitizer.bypassSecurityTrustUrl(previewUrl);
          info.blob = webpFile; // guardamos el WebP
        })
        .catch(err => {
          console.error('Error al convertir a WebP, uso original:', err);
          const previewUrl = URL.createObjectURL(file);
          info.infoImageUrl = this.sanitizer.bypassSecurityTrustUrl(previewUrl);
          info.blob = file;
        })
        .finally(() => this.cdr.detectChanges());
    } else {
      const previewUrl = URL.createObjectURL(file);
      info.infoVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(previewUrl);
      info.videoBlob = file;
      info.videoUrlType = 1;
      this.cdr.detectChanges();
    }
  }

  private convertImageToWebP(file: File, maxSize = 1920, quality = 0.8): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxSize || height > maxSize) {
          const scale = maxSize / Math.max(width, height);
          width = Math.round(width * scale);
          height = Math.round(height * scale);
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Canvas ctx null');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) return reject('No blob');
            const webpFile = new File(
              [blob],
              file.name.replace(/\.\w+$/, '.webp'),
              { type: 'image/webp' }
            );
            resolve(webpFile);
          },
          'image/webp',
          quality
        );
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  }

  blobFile = async ($event: any): Promise<any> => {
    try {
      const unSafeImg = window.URL.createObjectURL($event);
      const img = this.sanitizer.bypassSecurityTrustUrl(unSafeImg);
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve({
            blob: $event,
            img,
            base: reader.result
          });
        };
        reader.onerror = (error) => {
          reject({
            blob: $event,
            img,
            base: null
          });
        };
        reader.readAsDataURL($event);
      });
    } catch (e) {
      return Promise.reject(null);
    }
  };

  async updateComponentFiles(): Promise<void> {
    try {
      const uploadPromises = this.component.componentInfo.map(async (info: any) => {
        if (info.blob) {
          const timestamp = Date.now();
          const ext = info.blob.type === 'image/webp' ? 'webp' : (info.blob.name.split('.').pop() || 'jpg');
          const key = `${this.themingService.shopId}/${environment.stage}/images/components/component_${timestamp}.${ext}`;

          const uploaded = await this.lambdaService.uploadFile(key, info.blob, { position: 1, type: 'original' });
          info.infoImageUrl = (uploaded as { imageURL: string }).imageURL;
          info.blob = null;
        }

        if (info.videoUrlType == 1 && info.videoBlob) {
          const timestamp = Date.now();
          const ext = info.videoBlob.name.split('.').pop();
          const key = `${this.themingService.shopId}/${environment.stage}/videos/components/component_${timestamp}.${ext}`;

          const uploaded = await this.lambdaService.uploadFile(key, info.videoBlob, { position: 1, type: 'original' });
          info.infoVideoUrl = (uploaded as { imageURL: string }).imageURL;
          info.videoBlob = null;
        }
      });

      await Promise.all(uploadPromises);
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  }

  onVideoSourceChange(index: number, event: any): void {
    const selectedValue = event.target.value;
    const info = this.component.componentInfo[index];

    if (selectedValue == 1) {
        info.previousManualUrl = info.infoVideoUrl;
        info.infoVideoUrl = info.previousVideoUrl || info.infoVideoUrl || '';
        info.videoBlob = null;
        info.isYouTube = false;
    } else {
        info.previousVideoUrl = info.infoVideoUrl;
        info.infoVideoUrl = info.previousManualUrl || info.infoVideoUrl;
    }

    info.videoUrlType = selectedValue;
}

  async deletePreviousFiles(): Promise<void> {
    const deleteS3Promises = [];
    for (const url of this.urlsToDelete) {
      const cleanedUrl = url.replace('https://mobydyg-files.s3.amazonaws.com/', '');
      deleteS3Promises.push(this.lambdaService.deleteFile(cleanedUrl));
    }
    try {
      await Promise.all(deleteS3Promises);
    } catch (error) {
      console.error(error);
    }
    this.urlsToDelete = [];
  }
  isInvalidHttpUrl(url: string): boolean {
    if (!url) return false;
    return !/^https?:\/\/.+/i.test(url.trim());
  }

  async validateFormData(): Promise<void> {
    this.loading = true;
    // Validar redirectUrl en edición
    for (const [i, info] of this.component.componentInfo.entries()) {
      const url = info.redirectUrl?.trim();
      if (url && !/^https?:\/\/.+/i.test(url)) {
        this.itemListId = `${i + 1}`;
        $('#errorEditRedirectUrl').modal('show');
        this.loading = false;
        return;
      }
    }

    try {
        await this.updateComponentFiles();
        await this.deletePreviousFiles();

        const videoUrls = this.component.componentInfo.map((info: any) => {
            if (info.videoUrlType == 2) {
                return info.videoManualURL || info.infoVideoUrl || '';
            } else {
                return info.infoVideoUrl || '';}}).join('|');

        await this.lambdaService.updateComponent(
            this.component.componentId,
            this.themingService.shopId,
            this.sanitizeString(this.component.title),
            this.sanitizeString(this.component.subtitle),
            this.sanitizeString(this.component.description),
            this.component.shopContactMail,
            this.component.itemQuantity,
            this.component.itemListId,
            this.component.itemSort,
            this.component.componentInfo.map((info: any) => info.infoImageUrl || '').join('|'),
            this.component.componentInfo.map((info: any) => this.sanitizeString(info.infoDescription || '')).join('|'),
            this.component.componentInfo.map((info: any) => this.sanitizeString(info.redirectUrl || '')).join('|'),
            this.component.componentInfo.map((info: any) => info.infoId.toString() || '').join('|'),
            this.deletedInfoIds.join('|'),
            this.component.componentInfo.map((info: any) => this.sanitizeString(info.infoTitle || '')).join('|'),
            this.component.componentInfo.map((info: any) => this.sanitizeString(info.urlName || '')).join('|'),
            this.collectionId,
            this.categoryId,
            this.subCategoryId,
            this.subSubCategoryId,
            this.productComponentType || this.component.productComponentType,
            this.component.componentTypeId,
            this.sanitizeString(this.component.componentName),
            videoUrls,
            this.component.componentInfo.map((info: any) => info.videoUrlType).join('|'),
            this.component.pageId,
            this.component.status,
            this.subsAllowed
        );

        this.loading = false;
        $('#successEditComponentModal').modal('show');
        this.getComponentById(this.componentId);
    } catch (error) {
        console.error(error);
        this.loading = false;
        $('#errorEditComponentModal').modal('show');
    }
}

  sanitizeString(str: string): string {
    if (!str) return '';
    return str.trim();
  }

  closeModal(): void {
    $('#successEditComponentModal').modal('hide');
    $('#errorEditComponentModal').modal('hide');
    $('#errorEditMaxMinItemModal').modal('hide');
    $('#errorFileSizeModal').modal('hide');
    $('#errorEditRedirectUrl').modal('hide');
  }

}
